function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/*#__PURE__*/ /* eslint-disable camelcase */ import { utils } from "ethers";
import { FetcherError } from "./error-helper";
import { sleep } from "./promise.helpers";
import { CORE_POLLING_INTERVAL } from "../consts/index";
import { LightweightStateV2__factory } from "../contracts/index";
export const loadDataFromRarimoCore = function() {
    var _ref = _async_to_generator(function*(url, rarimoCoreUrl, blockHeight) {
        const response = yield fetch(`${rarimoCoreUrl}${url}`, {
            headers: _object_spread({
                'Content-Type': 'application/json'
            }, blockHeight && {
                'X-Cosmos-Block-Height': blockHeight
            })
        });
        if (!response.ok) {
            throw new FetcherError(response);
        }
        return yield response.json();
    });
    return function loadDataFromRarimoCore(url, rarimoCoreUrl, blockHeight) {
        return _ref.apply(this, arguments);
    };
}();
export const getUpdateStateDetails = function() {
    var _ref = _async_to_generator(function*(state, operation, rarimoCoreUrl) {
        let operationProof;
        do {
            try {
                operationProof = yield loadDataFromRarimoCore(`/rarimo/rarimo-core/rarimocore/operation/${state.lastUpdateOperationIndex}/proof`, rarimoCoreUrl);
            } catch (e) {
                if (e instanceof FetcherError && e.response.status === 400) {
                    yield sleep(CORE_POLLING_INTERVAL);
                } else {
                    throw e;
                }
            }
        }while (!operationProof)
        const decodedPath = operationProof.path.map((el)=>utils.arrayify(el));
        const decodedSignature = operationProof.signature ? utils.arrayify(operationProof.signature) : undefined;
        if (!decodedSignature) {
            throw new Error('Signature is not defined');
        }
        if (decodedSignature[64] !== undefined) {
            decodedSignature[64] += 27;
        }
        const proof = utils.defaultAbiCoder.encode([
            'bytes32[]',
            'bytes'
        ], [
            decodedPath,
            decodedSignature
        ]);
        return {
            stateRootHash: operation.details.stateRootHash,
            gistRootDataStruct: {
                root: operation.details.GISTHash,
                createdAtTimestamp: Number(operation.details.timestamp)
            },
            proof
        };
    });
    return function getUpdateStateDetails(state, operation, rarimoCoreUrl) {
        return _ref.apply(this, arguments);
    };
}();
export const getUpdateStateTx = function() {
    var _ref = _async_to_generator(function*(accountId, chainInfo, state, operation, rarimoCoreUrl, updateStateDetails) {
        const { stateRootHash , gistRootDataStruct , proof  } = updateStateDetails !== null && updateStateDetails !== void 0 ? updateStateDetails : yield getUpdateStateDetails(state, operation, rarimoCoreUrl);
        const contractInterface = LightweightStateV2__factory.createInterface();
        const txData = contractInterface.encodeFunctionData('signedTransitState', [
            stateRootHash,
            gistRootDataStruct,
            proof
        ]);
        return {
            to: chainInfo.stateContractAddress,
            from: accountId,
            chainId: chainInfo.id,
            data: txData
        };
    });
    return function getUpdateStateTx(accountId, chainInfo, state, operation, rarimoCoreUrl, updateStateDetails) {
        return _ref.apply(this, arguments);
    };
}();

//# sourceMappingURL=state-v2-helpers.js.map